
export type EnrollmentCreateFailedResult = typeof EnrollmentCreateFailedResult[keyof typeof EnrollmentCreateFailedResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentCreateFailedResult = {
  failed: 'failed',
} as const;
